import RestorationObjectModule from '../store/restoration_object'
import RestorationWorkModule from '../store/restoration_work'
import UIModule from '../store/ui'

export default ({ app, Vue }) => {
  const store = app.store

  const restorationObject = new RestorationObjectModule({
    store,
    name: 'restorationObject'
  })

  const restorationWork = new RestorationWorkModule({
    store,
    name: 'restorationWork'
  })

  const ui = new UIModule({
    store,
    name: 'ui'
  })

  restorationObject.setCollectionItemModule(Vue.prototype.oarepo$.collectionItemModule)
  restorationObject.setCollectionModule(Vue.prototype.oarepo$.collectionModule)
  Vue.prototype.$restorationObject = restorationObject
  Vue.prototype.$restorationWork = restorationWork
  Vue.prototype.$ui = ui
}
